import React from 'react';

const Materialno = () => {
  return (
    <div>
      <div className='text-center font-bold'>
        МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ
      </div>
      <div className='text-center font-bold p-4'>
        Сведения о наличии оборудованных учебных кабинетов
      </div>
      <p>
        ЧОУ ДПО «Профф» оказывает образовательные услуги в сфере дополнительного
        профессионального образования и профессионального обучения. Деятельность
        по оказанию образовательных услуг учебный центр осуществляет по адресу:
        Тюменская обл., ХМАО - Югра, г.Пыть-Ях, 6 мкр, «Пионерный», дом 30.,
        право владения и пользования зданием по указанному адресу возникло на
        основании договора аренды. Все арендуемые помещения соответствуют
        обязательным нормам пожарной безопасности и санитарно–эпидемиологическим
        требованиям.
      </p>
      <p>
        Центр располагает современной материально – технической базой, активно
        применяет современные методы и технические средства обучения.
      </p>
      <p>
        Учебные аудитории и помещения ЧОУ ДПО «Профф» оснащены необходимыми
        мебелью и оборудованием, позволяющими эффективно организовать и
        проводить учебный процесс. Учебный центр располагает 8 учебными
        классами, комнатой отдыха для приема пищи обучающимися, кабинетом для
        работы отдела организации обучения, кабинетом специалиста по ОТ,
        кабинетом специалиста ОК, кабинетом Генерального директора.
      </p>
      <p>
        В Учебный центр за весь период деятельности не было обращений инвалидов
        и лиц с ограниченными возможностями здоровья по вопросу обучения. Тем не
        менее, согласно Федеральному закону Российской Федерации от 29 декабря
        2012 г. N 273-ФЗ «Об образовании в Российской Федерации» Учебным центром
        созданы условия для обучения инвалидов и лиц с ОВЗ, для их сопровождения
        и осуществления индивидуального подхода к обучению, предусмотрены
        возможности и мероприятия, описанные ниже в справке. Все учебные классы
        и вспомогательные помещения расположены на первом этаже. Во все
        аудитории обеспечен доступ для маломобильных обучающихся, также все
        дверные проемы в аудиториях расширены.
      </p>
      <p> </p>
      <div className='text-center font-bold p-4'>
        Сведения об обеспечении образовательной деятельности оборудованными
        учебными кабинетами, помещениями и иными объектами
      </div>
      <table className='border border-gray-500'>
        <thead className='border border-gray-500 text-center'>
          <tr className='border border-gray-500'>
            <th className='border border-gray-500'>№</th>
            <th className='border border-gray-500 w-12'>
              Адрес места осуществления образовательной деятельности
            </th>
            <th className='border border-gray-500 w-16'>
              Реквизиты санитарно-эпидемиологического заключения и заключения
              Госпожнадзора
            </th>
            <th className='border border-gray-500'>
              Наименование учебных кабинетов с перечнем основного оборудования
            </th>
            <th className='border border-gray-500'>№ каб.</th>
          </tr>
        </thead>
        <tbody>
          <tr className='odd'>
            <td className='border border-gray-500'>1.</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p className='font-bold'>Кабинет № 1 </p>
              <p className='font-bold'>
                Оборудование и технические средства обучения:
              </p>
              <table>
                <thead>
                  <tr>
                    <td>МАКЕТ &#34;ПОРШЕНЬ&#34; ТРАКТОР К-700</td>
                    <td>1</td>
                    <td>шт</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАНОМЕТР ДАВЛЕНИЯ МАСЛА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ФИЛЬТР МАСЛЯНЫЙ&#34; В РАЗРЕЗЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРБЮРАТОР&#34; ГАЗ -53
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТОПЛИВНЫЙ ФИЛЬТР&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;БЕНЗОНАСОС&#34; ЗИЛ-130
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРБЮРАТОР&#34; КАВЗ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;БЕНДИКС&#34; СТАРТЕР КАМАЗ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТНВД&#34; КАМАЗ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ГОЛОВКА ДВИГАТЕЛЯ 402&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТОК ИНДУКЦИЙ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРБЮРАТОР&#34; ЗИЛ-130
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРЗИНА СЦЕПЛЕНИЯ&#34; УАЗ-ВОЛГА
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРЗИНА СЦЕПЛЕНИЯ&#34; ВАЗ-2109
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ПОРШЕНЬ&#34; КАМАЗ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;РАСПРЕДВАЛ&#34; ГАЗ-53
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАНОМЕТР ДАВЛЕНИЯ МАСЛА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КОЛЕНВАЛ ДВС&#34; УРАЛ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ДИСК СЦЕПЛЕНИЯ&#34; ВОЛГА
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТНВД&#34; В РАЗРЕЗЕ УРАЛ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТНВД&#34; КАМАЗ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАСЛЯННЫЙ НАСОС&#34; УРАЛ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАСЛЯННЫЙ НАСОС&#34; ЗАЛ-130
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ДВИГАТЕЛЯ&#34; ГАЗ-53
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;НЕЗАВИСИМОЙ ПОДВЕСКИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ВАКУУМНОГО УСИЛИТЕЛЯ ТОРМОЗНОЙ СИСТЕМЫ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ГАЗОВОГО РЕДУКТОРА-СМЕСИТЕЛЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;СИНХРОНИЗАТОР КПП&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;РАЗДАТОЧНОЙ КОРОБКИ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МЕХАНИЗМ ОПЕРЕЖЕНИЯ ЗАЖИГАНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ВЕДУЩЕГО ЗАДНЕГО МОСТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАСЛЯНОГО ФИЛЬТРА&#34; ЦЕНТРИФУГА
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МЕХАНИЗМА ПЕРЕКЛЮЧЕНИЯ ПЕРЕДАЧИ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;СЦЕПЛЕНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ВЕДУШЕГО УПРАВЛЯЕМОГО МОСТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ПРОБКИ РАДИАТОРА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;РЕГУЛЯТОРА ВЫСОКОГО ДАВЛЕНИЯ ДИЗЕЛЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ОБГОННОЙ МУФТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ПНЕВМАТИЧЕСКОГО ТОРМОЗА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;МАСЛЯНОГО ФИЛЬТРА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ГИДРОУСИЛИТЕЛЯ РУЛЕВОГО УПРАВЛЕНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТОРМОЗНОГО МЕХАНИЗМА №1&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ТОРМОЗНОГО МЕХАНИЗМА №2&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КОРОБКИ ПЕРЕДАЧ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КРИВОШИПНО-ШАТУННОГО МЕХАНИЗМА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КПП СИНХРОНИЗАТОРА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;КАРБЮРАТОР&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ЛОПАСНОГО НАСОСА ГИДРОУСИЛИТЕЛЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ВОЗДУШНОГО КОМПРЕССОРА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ПЕРЕДНЕГО ВЕДУЩЕГО УПРАВЛЯЕМОГО МОСТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МАКЕТ &#34;ЗАДНИЙ ПРИВОД&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДОРОЖНАЯ РАЗМЕТКА&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СИГНАЛЫ СВЕТОФОРОВ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДВИЖЕНИЕ ПО Ж/Д ПЕРЕЕЗДАМ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ТРЕБОВАНИЯ К ОБОРУДОВАНИЮ ТС&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗНАКИ ОПАСНОСТИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;МАРКИРОВКА ТАРЫ И КРЕПЛЕНИЕ ГРУЗОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;МАРКИРОВКА ТС И ТРАНСПОРТНОГО
                      ОБОРУДОВАНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;НЕИСПРАВНОСТИ И УСЛОВИЯ, ПРИ КОТОРЫХ ЗАПРЕЩЕНА
                      ЭКСПЛУАТАЦИЯ ТС&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДОРОЖНЫЕ ЗНАКИ&#34;
                    </td>
                    <td className='border border-gray-500'>8</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРОВЕРКА ТЕХНИЧЕСКОГО СОСТОЯНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СЛЕСАРНЫЕ, СВАРОЧНЫЕ И РЕГУЛИРОВОЧНЫЕ
                      РАБОТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ШИНОМОНТАЖ И ШИНОРЕМОНТ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ГРУЗОПОДЪЕМНОЕ И ПОДЪЕМНО-ТРАНСПОРТНОЕ
                      ОБОРУДОВАНИЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПОСТАНОВКА НА ПОСТ ТО И РЕМОНТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОГНИ СУДОВ И ПЛОТОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗАПРЕЩАЮЩИЕ ЗНАКИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗНАКИ &#34;ОРИЕНТИР&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, БУКСИРУЮЩЕЕ ПЛОТ ИЛИ СМЕННЫЙ
                      СОСТАВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОГНИ СУДОВ ТЕХНИЧЕСКОГО ФЛОТА&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДА, ОТШВАРТОВАННЫЕ БОРТАМИ И БУКСИРУЮЩИЕ
                      СОСТАВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;МНОГОЧЕРПАКОВЫЙ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОГНИ И ЗНАКИ РЫБОЛОВНЫХ СУДОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДНОУГЛУБИТЕЛЬНЫЙ СНАРЯД, РАБОТАЮЩИЙ НА ЛЕВОЙ
                      ПОЛОСЕ СУДОВОГО ХОДА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДА, СОЕДИНЕННЫЕ В КИЛЬВАТЕР, БУКСИРУЮЩИЕ
                      СОСТАВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, ЗАНЯТОЕ ВОДОЛАЗНЫМИ РАБОТАМИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗНАКИ И СИГНАЛЬНЫЕ ФЛАГИ СУДОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, ЗАНЯТОЕ БУКСИРОВКОЙ НА ТРОСЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПЛАВУЧИЙ КРАНДЛИН МЕНЕЕ 50М, ПРОИЗВОДЯЩИЙ
                      ДОБЫЧУ ГРУНТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО У ПЛОТА, ПОМОГАЮЩЕЕ ЕГО ПРОВОДКЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДНОУГЛУБИТЕЛЬНЫЙ СНАРЯД, РАБОТАЮЩИЙ НА ПРАВОЙ
                      ПОЛОСЕ СУДОВОГО ХОДА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОПОЗНАВАТЕЛЬНЫЕ ЗНАКИ И ИХ СИГНАЛЬНЫЕ
                      ОГНИ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗНАК &#34;ПУТЕВОЙ ОГОНЬ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОСЕВЫЕ СТВОРЫ НА МЕСТНОСТИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СТВОРНЫЕ И ГАБАРИТНЫЕ ОГНИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОГНИ САМОХОДНЫХ СУДОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРИ ГАБАРИТНОЙ ВЫСОТЕ ОТ 10 ДО 13М&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРОХОД ВОСПРЕЩЕН ВНИЗ И ВВЕРХ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СИГНАЛЬНЫЕ ОГНИ КРОМОЧНЫХ СТВОРОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;РАССТАНОВКА ЗНАКОВ &#34;РАСХОЖДЕНИЕ И ОБГОН
                      ЗАПРЕЩЕНЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, ОТШВАРТОВАННОЕ К БОРТУ ДРУГОГО СУДНА
                      ИЛИ СОСТАВА&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;НАВИГАЦИОННЫЕ ЗНАКИ НА ПЛАВ МОСТАХ ДНЕМ И ОГНИ
                      НОЧЬЮ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;РАЗРЕШЕН ПРОХОД СУДАМ, ИДУЩИМ ВНИЗ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРИ ГАБАРИТНОЙ ВЫСОТЕ СВЫШЕ 16М&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРИ ГАБАРИТНОЙ ВЫСОТЕ ДО 10М&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;РАССТАНОВКА ЗНАКОВ &#34;ЯКОРЯ НЕ БРОСАТЬ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;УСЛОВНЫЕ ОБОЗНАЧЕНИЯ ОГНЕЙ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРИ ГАБАРИТНОЙ ВЫСОТЕ ОТ 13 ДО 16М&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, БУКСИРУЮЩЕЕ СОСТАВ С ТОЛКАЧОМ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СИГНАЛЬНЫЕ ОГНИ ЩЕЛЕВЫХ СТВОРОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРЯМОЛИНЕЙНЫЙ УЧАСТОК СУДОХОДНОГО КАНАЛА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;УЧАСТОК КАНАЛА С ВОДОХРАНИЛИЩЕМ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЩЕЛЕВЫЕ СТВОРЫ НА МЕСТНОСТИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;КРОМОЧНЫЕ СТВОРЫ ДЛЯ СВЕТЛОГО И ТЕМНОГО
                      ФОНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;РАЗРЕШЕН ПРОХОД СУДАМ, ИДУЩИМ ВВЕРХ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, БУКСИРУЮЩЕЕ ПОД БОРТОМ САМОХОДНОГО
                      СУДНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ДНООЧИСТИТЕЛЬНЫЙ СНАРЯД, ЗАНИМАЮЩИЙСЯ
                      ПОДВОДНЫМИ РАБОТАМИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ТИПЫ ПЕРЕВАЛЬНЫХ ЗНАКОВ ДЛЯ СВЕТЛОГО И ТЕМНОГО
                      ФОНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, ОКАЗЫВАЮЩЕЕ ПОМОЩЬ ДРУГОМУ СУДНУ
                      БУКСИРОВКОЙ НА ТРОСЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;РЫБОЛОВНОЕ СУДНО НА ХОДУ, НЕ ЗАНЯТОЕ ЛОВОМ
                      РЫБЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СУДНО, ЗАНЯТОЕ ЛОВОМ РЫБЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СТВОРНЫЕ ГАБАРИТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СИГНАЛЬНЫЕ ОГНИ СЕТЕВЫХ СТВОРОВ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;УКАЗАТЕЛИ ОСИ СУДОВОГО ХОДА И ГАБАРИТНОЙ
                      ВЫСОТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОСЕВЫЕ СТВОРЫ ДЛЯ СВЕТЛОГО И ТЕМНОГО ФОНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЩЕЛЕВЫЕ СТВОРЫ ДЛЯ СВЕТЛОГО И ТЕМНОГО
                      ФОНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЧАСЫ &#34;КОЛЕСО&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТЕНД &#34;КРИВОШИПНО-ШАТУННЫЙ МЕХАНИЗМ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      СТЕНД &#34;ГАЗОРАСПРЕДЕЛИТЕЛЬНЫЙ МЕХАНИЗМ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТЕНД &#34;СИСТЕМА ПИТАНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЖАЛЮЗИ КОРИЧНЕВЫЕ
                    </td>
                    <td className='border border-gray-500'>4</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МОНИТОР &#34;ACER&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КЛАВИАТУРА &#34;ARTI RSI&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СИСТЕМНЫЙ БЛОК &#34;FORUM&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КРЕСЛО УЧИТЕЛЬСКОЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>м3</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      TV &#34;SAMSUNG&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      DVD &#34;LG&#34;+5 КОЛОНОК
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ДИСТАНЦИОННОЕ УПРАВЛЕНИЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>КНИЖНЫЙ ШКАФ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТОЛ-ТУМБА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ПАРТА</td>
                    <td className='border border-gray-500'>6</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>12</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      СПЕЦ. ОДЕЖДА ДЛЯ СНЕГОХОДА
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ЩЛЕМ ДЛЯ УПРАВЛЕНИЯ
                    </td>
                    <td className='border border-gray-500'>5</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЧЕРЕПАХА (ЗАЩИТА)
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>НАКОЛЕННИКИ</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЛАВИННИК ДЛА СНЕГОХОДА
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 1</td>
          </tr>
          <tr className='even'>
            <td className='border border-gray-500'>2.</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 2 </p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>Вешалка</th>
                    <th>1</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТЕНД &#34;УГОЛОК ГРАЖДАНСКОЙ ОБОРОНЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ЭКРАН</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      DVD &#34;Panasonik&#34;+5 колонок+1 сабвуфер
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>Системный Блок</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МОНИТОР &#34;PHILIPS
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КОМПЬЮТЕРНЫЕ КОЛОНКИ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КЛАВИАТУРА &#34;GENIUS&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МУЛЬТИМЕДИЙНЫЙ ПРОЕКТОР &#34;ACER&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КРЕСЛО УЧИТЕЛЬСКОЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      Мышь компьютерная
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ЖАЛЮЗИ БЕЛЫЕ</td>
                    <td className='border border-gray-500'>4</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>&#34;МАКСИМ&#34;</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ДИСТАНЦИОННОЕ УПРАВЛЕНИЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТЕНД</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>КНИЖНЫЙ ШКАФ</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>КОСТЮМ ХИМЗАЩИТЫ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ПРОТИВОГАЗ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ТУМБА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>18</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ</td>
                    <td className='border border-gray-500'>10</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПЕРВАЯ МЕДИЦИНСКАЯ ПОМОЩЬ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПОЖАРНАЯ БЕЗОПАСНОСТЬ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;АВАРИЙНО-СПАСАТЕЛЬНЫЕ И ДРУГИЕ НЕОТЛОЖНЫЕ
                      РАБОТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СРЕДСТВА ИНДИВИДУАЛЬНОЙ ЗАЩИТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПРОСТЕЙШИЕ УКРЫТИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'> № 2</td>
          </tr>
          <tr className='odd'>
            <td className='border border-gray-500'>3.</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 3.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>МАНЕКЕН</th>
                    <th>13</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ШИРМА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ</td>
                    <td className='border border-gray-500'>9</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>12</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>Вешалка</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЖАЛЮЗИ КОРИЧНЕВЫЕ
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ЖАЛЮЗИ КОФЕ С МОЛОКОМ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ШКАФ ПЕНАЛ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ШВЕЙНАЯ МАШИНКА С ПЕД. &#34;АСТРАЛЮКС&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ОВЕРЛОГ С ПЕДАЛЬЮ &#34;АСТРАЛЮКС&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ДОСКА ГЛАДИЛЬНАЯ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      УТЮГ &#34;АТЛАНТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ЗЕРКАЛО</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ТУМБА</td>
                    <td className='border border-gray-500'>5</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ-КРЕСЛО</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ТЕЛЕВИЗОР &#34;OREON&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 3</td>
          </tr>
          <tr className='even'>
            <td className='border border-gray-500'>4</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 4.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>МАНЕКЕН</th>
                    <th>13</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ШИРМА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ</td>
                    <td className='border border-gray-500'>9</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>12</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>Вешалка</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЖАЛЮЗИ КОРИЧНЕВЫЕ
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ЖАЛЮЗИ КОФЕ С МОЛОКОМ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ШКАФ ПЕНАЛ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ШВЕЙНАЯ МАШИНКА С ПЕД. &#34;АСТРАЛЮКС&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ОВЕРЛОГ С ПЕДАЛЬЮ &#34;АСТРАЛЮКС&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ДОСКА ГЛАДИЛЬНАЯ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      УТЮГ &#34;АТЛАНТА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ЗЕРКАЛО</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ТУМБА</td>
                    <td className='border border-gray-500'>5</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ-КРЕСЛО</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ТЕЛЕВИЗОР &#34;OREON&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 4</td>
          </tr>
          <tr className='odd'>
            <td className='border border-gray-500'>5</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 5.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>ТУМБА</th>
                    <th>2</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      МОНИТОР &#34;ACER&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КЛАВИАТУРА &#34;GENIUS&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КОЛОНКИ &#34;SVEN&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КРЕСЛО УЧИТЕЛЬСКОЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      СИСТЕМНЫЙ БЛОК &#34;IN WIN&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      Мышь компьютерная
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЛАМПА &#34;SNEHA&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ЖАЛЮЗИ БЕЖЕВЫЕ</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЭЛЕКТРОИНСТРУМЕНТ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ЭКРАН</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;СРЕДСТВА ЗАЩИТЫ В ЭЛ.УСТАНОВКАХ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОРГАНИЗАЦИЯ ОБЕСПЕЧЕНИЯ
                      ЭЛЕКТРОБЕЗОПАСНОСТИ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ</td>
                    <td className='border border-gray-500'>6</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>12</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МУЛЬТИМЕДИЙНЫЙ ПРОЕКТОР &#34;ACER&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 5</td>
          </tr>
          <tr className='even'>
            <td className='border border-gray-500'>6</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 6.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>ЗЕРКАЛО</th>
                    <th>7</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>КРЕСЛО МАССАЖНОЕ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ МАНИКЮРНЫЙ</td>
                    <td className='border border-gray-500'>5</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      TV &#34;SONY&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ЖАЛЮЗИ РОЗОВЫЕ</td>
                    <td className='border border-gray-500'>4</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТУЛ УЧЕНИЧЕСКИЙ МЯГКИЙ
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧЕНИЧЕСКИЙ</td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТУЛ УЧЕНИЧЕСКИЙ ТВЕРДЫЙ
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>м3</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СВЕТИЛЬНИК &#34;МАЛИНОВЫЙ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КАМОД ПЛАСТИКОВЫЙ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПОЛКА ДЛЯ ИНСТРУМЕНТОВ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;АРБАТСКИЕ СИРОТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;ВИД НА МОРЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;ДЕВУШКА И РОЗА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;МАЛЬЧИК И ДЕВОЧКА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЗЕРКАЛО &#34;ЦВЕТОЧКИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТАТУЭТКА &#34;АНГЕЛОЧЕК&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      Светильники настольные Camelion KD-313 белый настольный
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      Светильники настольные Camelion KD-034 серебро+черный
                      настольный
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ВАЗА &#34;УРАЛЬСКИЕ САМОЦВЕТЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТЕРИЛИЗАТОР</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ЛАМПА JN 3000 &#34;NR PROFESSIONAL&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ЛАМПА JN 2000 &#34;NR PROFESSIONAL&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЫЛЕСОС Д/МАНИКЮРА DC-248C
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КУШЕТКА &#34;МОРСКАЯ ВОЛНА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ШКАФ ДВУСТВОРЧАТЫЙ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ШКАФ СО СТЕКЛЯННЫМИ ДВЕРЦАМИ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;ЛОДКИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;МАКИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;ЛОДКА НА МОРЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КАРТИНА &#34;СЛОНЕНОК&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КРЕСЛО ВРАЩАЮЩЕЕСЯ ЧЕРНОЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      КРЕСЛО ВРАЩАЮЩЕЕСЯ СИНЕЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ФЕН &#34;ROWENTA&#34; EN-1700B
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 6</td>
          </tr>
          <tr className='odd'>
            <td className='border border-gray-500'>7</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 7.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>ДОСКА</th>
                    <th>1</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      КРЕСЛО УЧИТЕЛЬСКОЕ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>ПАРТА</td>
                    <td className='border border-gray-500'>4</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      СТУЛ УЧЕНИЧЕСКИЙ ТВЕРДЫЙ
                    </td>
                    <td className='border border-gray-500'>7</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОСНОВНЫЕ ТРЕБОВАНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЦЕНТРАЛИЗОВАННОЕ ГАЗОПИТАНИЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;БАЛОННОЕ ГАЗОПИТАНИЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОСОБЫЕ УСЛОВИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЗАЩИТНЫЕ СРЕДСТВА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЭЛЕКТРОБЕЗОПАСНОСТЬ ПРИ РУЧНОЙ ГАЗОВОЙ
                      СВАРКЕ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ГАЗОВАЯ СВАРКА&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ВЗРЫВО И ПОЖАРОБЕЗОПАСНОСТЬ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ТЕХНИКА РЕАНИМАЦИИ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ЭЛЕКТРОТРАВМЫ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОСТАНОВКА КРОВОТЕЧЕНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ТРАНСПОРТНАЯ ИММОБИЛИЗАЦИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПЕРЕНОС ПОСТРАДАВШИХ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ОЖОГИ, ОТРАВЛЕНИЯ, ОБМОРОЖЕНИЯ&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ПОЖАРНАЯ БЕЗОПАСНОСТЬ&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 7</td>
          </tr>
          <tr className='even'>
            <td className='border border-gray-500'>8</td>
            <td className='border border-gray-500'>
              <p>628383, РФ, Тюменская обл., ХМАО - Югра,</p>
              <p>г. Пыть-Ях, 6 мкр, «Пионерный», дом 30.</p>
            </td>
            <td className='border border-gray-500'>
              <p>
                Санитарно – эпидемиологическое заключение
                №86.НП.01.000.М.000023.04.17 от 05.04.2017 г.
              </p>
              <p>
                Заключение о соответствии объекта защиты обязательным
                требованиям пожарной безопасности № 27/44 от 08.10.2015г.
              </p>
            </td>
            <td className='border border-gray-500'>
              <p>Кабинет № 8.</p>
              <p>Оборудование и технические средства обучения:</p>
              <table>
                <thead>
                  <tr className='header'>
                    <th>СТУЛ-КРЕСЛО</th>
                    <th>1</th>
                    <th>шт</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТОЛ УЧЕНИЧЕСКИЙ</td>
                    <td className='border border-gray-500'>9</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      СТУЛ УЧЕНИЧЕСКИЙ МЯГКИЙ
                    </td>
                    <td className='border border-gray-500'>9</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      СТУЛ УЧЕНИЧЕСКИЙ ТВЕРДЫЙ
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>СТОЛ УЧИТЕЛЬСКИЙ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>СТУЛ</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ДОСКА</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>м3</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ТУМБА ДЛЯ ПЛАКАТОВ
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      МОНИТОР &#34;ACER&#34;
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      Клавиатура компьютерная
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>Мышь defenden</td>
                    <td className='border border-gray-500'>5</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>Системный Блок</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>Мышь оптическая</td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      15.6&#34; Ноутбук НР 15-af002ur (HD) AMD E1-6015
                      (1.4)/2048/500/AMD Radeon R2/DVD-SMulti/WiFi/Cam/Win8.1
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      Ноутбук Lenovo IdeaPad B5045
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      Ноутбук HP 255G3 433
                    </td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      Ноутбук Lenovo G50-30 8060
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      Ноутбук Dell P28F
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>ШКАФ книжный</td>
                    <td className='border border-gray-500'>1</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='odd'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;ФИЗ.ПАУЗА&#34;
                    </td>
                    <td className='border border-gray-500'>3</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                  <tr className='even'>
                    <td className='border border-gray-500'>
                      ПЛАКАТ &#34;КОМПЬЮТЕР И БЕЗОПАСНОСТЬ&#34;
                    </td>
                    <td className='border border-gray-500'>2</td>
                    <td className='border border-gray-500'>шт</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className='border border-gray-500'>№ 8</td>
          </tr>
        </tbody>
      </table>
      <p>Сведения об объектах для проведения практических занятий</p>
      <p>
        Для обеспечения качественной подготовки обучающихся по дополнительным
        профессиональным программам и основным программам профессионального
        обучения Учебным центром заключены договора на прохождение практики и
        стажировки с предприятиями города. С Муниципальным дошкольным
        образовательным автономным учреждением детский сад общеразвивающего вида
        «Белочка» с приоритетным осуществлением деятельности по физическому
        развитию детей (МДОАУ д/с «Белочка») , заключен Договор о стажировке
        обучающихся ЧОУ ДПО «Профф» по следующим программам:
      </p>
      <p>- «Младший воспитатель» - 3 разряда.</p>
      <p>- «Повар» - 2, 3, 4, 5, 6 разряда.</p>
      <p>
        С Обществом с ограниченной ответственностью «Борец сервис-Нефтеюганск»
        (ООО &#34;Борец сервис-Нефтеюганск&#34;) , заключен Договор о стажировке
        обучающихся ЧОУ ДПО «Профф» по следующим программам:
      </p>
      <p>- «Токарь» - 2 - 4 разряд,</p>
      <p>- «Фрезеровщик» - 2 - 4 разряд,</p>
      <p>- «Контролер станочных и слесарных работ» - 2 - 4 разряд,</p>
      <p>- «Слесарь-ремонтник» - 2 - 4 разряд,</p>
      <p>- «Кладовщик» - 2 - 4 разряд,</p>
      <p>
        - «Электромонтер по ремонту и обслуживанию электрооборудования» - 2 - 5
        разряд,
      </p>
      <p>- «Приемосдатчик груза и багажа»,</p>
      <p>- «Монтер кабельного производства» - 3 - 4 разряд.</p>
      <p>
        С Обществом с ограниченной ответственностью «Мегатек» (ООО «Мегатек»),{' '}
        заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по следующим
        программам:
      </p>
      <p>- «Водитель погрузчика» - 2, 4, 5, 6, 7 разряд;</p>
      <p>- «Машинист крана автомобильного» - 4, 5, 6, 7, 8 разряд;</p>
      <p>- «Машинист трубоукладчика» - 5, 6, 7, 8 разряд;</p>
      <p>- «Машинист крана манипулятора»;</p>
      <p>- «Стропальщик» - 2, 3, 4, 5, 6 разряд;</p>
      <p>- «Электрогазосварщик» - 2,3,4,5,6 разряд;</p>
      <p>- «Монтажник технологических трубопроводов» - 2,3,4,5,6,7 разряд.</p>
      <p>
        С Обществом с ограниченной ответственностью «Арсенал» (ООО «Арсенал»),{' '}
        заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по следующим
        программам:
      </p>
      <p>- «Слесарь-ремонтник»;</p>
      <p>- «Стропальщик»;</p>
      <p>- «Электрогазосварщик»;</p>
      <p>- «Электромонтер по ремонту и обслуживанию электрооборудования»;</p>
      <p>- «Токарь».</p>
      <p>
        С бюджетным учреждением Ханты-Мансийского автономного округа - Югры
        «Пыть-Яхская окружная клиническая больница» (БУ «Пыть-Яхская окружная
        клиническая больница»), заключен Договор о стажировке обучающихся ЧОУ
        ДПО «Профф» по следующим программам:
      </p>
      <p>- «Младшая медицинская сестра по уходу за больными»;</p>
      <p>- «Санитарка»;</p>
      <p>
        С Обществом с ограниченной ответственностью «Автоспецтранс» (ООО «АСТ»),{' '}
        заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по следующим
        программам:
      </p>
      <p>- «Электрогазосварщик» 2-6 разряда;</p>
      <p>- «Машинист крана автомобильного» 4-8 разряда;</p>
      <p>- «Водитель погрузчика» 2-5 разряда;</p>
      <p>- «Машинист экскаватора» 4-6 разряда;</p>
      <p>- «Моторист ЦА 320» 5-6 разряда;</p>
      <p>- «Аккумуляторщик» 2-4 разряда;</p>
      <p>- «Машинист ППДУ» 3-6 разряда;</p>
      <p>- «Оператор (машинист) автомобильных кранов-манипуляторов»</p>
      <p>- «Машинист бульдозера» 4-6 разряда;</p>
      <p>- «Слесарь по ремонту автомобилей» 1-3 разряда.</p>
      <p>
        С Индивидуальным предпринимателем Хужулов Супьян Султанович (ИП Хужулов
        С.С.) заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по
        следующим программам:
      </p>
      <p>- «Электромонтер РОЭ» 2-4 разряда;</p>
      <p>- «Кладовщик» 1, 2 разряда.</p>
      <p>
        С Обществом с ограниченной ответственностью «Арбат» (ООО «Арбат»){' '}
        заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по следующим
        программам:
      </p>
      <p>- «Стропальщик»;</p>
      <p>- «Слесарь-ремонтник»;</p>
      <p>- «Кладовщик»;</p>
      <p>- «Приемосдатчик груза и багажа»;</p>
      <p>- «Составитель поездов».</p>
      <p>
        С Обществом с ограниченной ответственностью Ремонтный Инженерный Центр
        «КРАН» (ООО РИЦ “КРАН”), заключен Договор о стажировке обучающихся ЧОУ
        ДПО «Профф» по следующим программам:
      </p>
      <p>- «Машинист крана автомобильного»;</p>
      <p>- «Машинист автовышки и автогидроподъемника»;</p>
      <p>- «Машинист подъемника»;</p>
      <p>- «Машинист крана манипулятора»;</p>
      <p>- «Стропальщик»;</p>
      <p>- «Токарь»;</p>
      <p>- «Наладчик ПБ».</p>
      <p>
        С Обществом с ограниченной ответственностью «Содел» (ООО
        &#34;Содел&#34;), заключен Договор о стажировке обучающихся ЧОУ ДПО
        «Профф» по следующим программам:
      </p>
      <p>- «Категории транспортных средств А I, А II, А III, A IV»;</p>
      <p>- «Тракторист»;</p>
      <p>- «Бульдозерист»;</p>
      <p>- «Водитель погрузчика».</p>
      <p>
        С Обществом с ограниченной ответственностью «ТЮБИНГ ТЕХНОЛОДЖИ ЮГРА»
        (ООО «ТЮБИНГ ТЕХНОЛОДЖИ ЮГРА»), заключен Договор о стажировке
        обучающихся ЧОУ ДПО «Профф» по следующим программам:
      </p>
      <p>
        - «Ведущий инженер по контрольно-измерительным приборам и автоматике»;
      </p>
      <p>- «Ведущий технолог с правом управления автомобилем»;</p>
      <p>- «Водитель автомобиля 1 класса»;</p>
      <p>- «Главный механик»;</p>
      <p>
        - «Дефектоскопист по магнитному и ультразвуковому контролю» 5 разряда;
      </p>
      <p>- «Заведующий складом»;</p>
      <p>
        - «Инженер по контрольно-измерительным приборам и автоматике» 2
        категории;
      </p>
      <p>
        - «Контролер качества продукции и технологического процесса» 5 разряда;
      </p>
      <p>- «Контролер станочных и слесарных работ» 4 разряда;</p>
      <p>- «Маркировщик» 4 разряда;</p>
      <p>- «Мастер по ремонту оборудования»;</p>
      <p>- «Мастер погрузо-разгрузочных работ»;</p>
      <p>- «Машинист крана автомобильного» 6 разряда;</p>
      <p>- «Наладчик автоматов и полуавтоматов» 6 разряда;</p>
      <p>
        - «Оператор автоматических и полуавтоматических линий станков и
        установок по производству изделий из пластмасс» 4 разряда;
      </p>
      <p>
        - «Оператор автоматических и полуавтоматических линий станков и
        установок» 5 разряда;
      </p>
      <p>- «Оператор моечной установки» 4 разряда;</p>
      <p>
        - «Оператор станков с программным управлением (ленточнопильных)» 5
        разряда;
      </p>
      <p>
        - «Оператор станков с программным управлением (резьбонарезных)» 5
        разряда;
      </p>
      <p>- «Оператор станков с программным управлением» 5 разряда;</p>
      <p>- «Прессовщик на испытании труб» 5 разряда;</p>
      <p>- «Слесарь-ремонтник» 5 разряда;</p>
      <p>- «Слесарь по ремонту автомобилей» 4 разряда;</p>
      <p>- «Старший мастер цеха НКТ»;</p>
      <p>- «Старший мастер цеха муфт»;</p>
      <p>- «Стропальщик» 4 разряда;</p>
      <p>- «Токарь» 6 разряда;</p>
      <p>- «Электрогазосварщик» 5 разряда.</p>
      <p>
        С Обществом с ограниченной ответственностью Производственно Научная
        Фирма «Сибирский Технический Энергетический Сервис» (ООО ПНФ «СТЭС»),{' '}
        заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по следующим
        программам:
      </p>
      <p>
        - «Электромонтер по ремонту и обслуживанию электрооборудования» 2, 3, 4,
        5 ,6 разряда;
      </p>
      <p>- «Электромонтер ОВБ»;</p>
      <p>- «Электромонтер по обслуживанию подстанций»;</p>
      <p>- «Электромонтер по обслуживанию электроустановок»;</p>
      <p>- «Электромонтер по ремонту и монтажу кабельных линий»;</p>
      <p>- «Электромонтер по испытаниям и измерениям».</p>
      <p>
        С Обществом с ограниченной ответственностью «ТЮБИНГ РЕНТ» (ООО «ТЮБИНГ
        РЕНТ»), заключен Договор о стажировке обучающихся ЧОУ ДПО «Профф» по
        следующим программам:
      </p>
      <p>- «Кладовщик»;</p>
      <p>- «Отдел кадров»;</p>
      <p>- «Секретарь-референд»;</p>
      <p>- «Слесарь по ремонту автомобилей».</p>
      <p>
        А также заключены договора о производственной практике и стажировке с
        целым рядом других предприятий и организаций г. Пыть-Ях, Нефтеюганск,
        Салым.
      </p>
      <p>
        В ходе проведения теоретических занятий в учебном центре также
        предусмотрены практические занятия. Для этого используются
        программно-аппаратные и тренажерные комплексы:
      </p>
      <p>
        - Автоматизированная система обучения и проверки знаний «1С» - 10
        рабочих мест;
      </p>
      <p>
        - Автоматизированная система обучения и проверки знаний Тестирования -
        10 рабочих мест;
      </p>
      <p>
        - Тренажер – манекен Т12К «Максим III-01» для отработки приемов
        сердечно-легочной реанимация - 1 шт.;
      </p>
      <p>
        Средства обучения и воспитания, в том числе приспособленных для
        использования инвалидами и лицами с ограниченными возможностями здоровья
      </p>
      <p>
        - Электронная образовательная среда LMS Moodle с размещенными в ней
        методическими и иными учебными материалами;
      </p>
      <p>
        - LMS Moodle: с возможностью увеличивать шрифт, загружать аудиофайлы,
        демонстрирующие выполнение задание обучающимся;
      </p>
      <p>
        - Контрольно-измерительные материалы, хранящиеся в отделе организации
        обучения в бумажном или электронном виде;
      </p>
      <p>
        - Библиотека с печатными изданиями и электронными ресурсами – книжный
        фонд – 766 ед. печатные издания, электронные учебные издания – 150 ед.;
      </p>
      <p>- Консультации преподавателей;</p>
      <p>- Корпоративная электронная почта обучающихся и преподавателей;</p>
      <p>- 10 ноутбуков – имеют выход в интернет;</p>
      <p>- Электронные образовательные ресурсы;</p>
      <p>- МФУ – 7 шт.;</p>
      <p>- телевизор;</p>
      <p>- Маркерные доски в каждой учебной аудитории.;</p>
      <p>-Проекторы в каждой учебной аудитории;</p>
      <p>
        Обучающиеся имеют возможность работать в сети Интернет на уроках и
        ежедневно в свободном доступе после уроков в кабинетах №
        1,2,3,4,5,6,7,8. В свободное от уроков время каждый желающий
        (преподаватель или обучающийся) при помощи точки доступа к сети Интернет
        может воспользоваться техническими и сетевыми ресурсами для выполнения
        учебных задач.
      </p>
      <p>
        Создан, постоянно пополняющийся и обновляющийся сайт, на котором
        располагается информация: — об учебном центре; — об истории и развитии
        ЧОУ ДПД «Профф»; — о педагогических работниках. На сайте учебного
        центра размещаются важные документы, касающиеся организации
        образовательного процесса, самообследование, документы, регламентирующие
        работу Организации и др.
      </p>
      <p>Средства воспитания</p>
      <p>
        Современное образование должно быть направлено на развитие личности
        человека, раскрытие его возможностей, талантов, становление
        самосознания, самореализации. Развитее обучающегося, как личности (его
        социализация) идёт не только путём овладения им нормативной
        деятельностью, но и через постоянное обогащение, преобразование
        субъектного опыта, как важного источника собственного развития.
        Использование личностно – ориентированных технологий позволяет поставить
        в центр всей образовательной системы личность обучающегося, обеспечить
        комфортные, бесконфликтные и безопасные условия её развития, реализовать
        её природные потенциалы. Технологии личностной ориентации позволяют
        найти методы и средства обучения и воспитания, соответствующие
        индивидуальным особенностям каждого человека, перестроить содержание
        образования, противопоставить авторитарному подходу– атмосферу
        сотрудничества, создают условия для творчества и самоактуализации
        личности.   
        <br />
        <br />
        1. Общение как средство воспитания
      </p>
      <p>
        а- непосредственное, в форме прямых контактов преподавателя и
        обучающегося, индивидуальные беседы  
        <br />
        б- опосредованное, проявляющееся в том, что педагог направляет свои
        воздействия не на обучающегося, а на знания, которые тот должен усвоить,
        на профессиональные качества, которые он должен сформировать в процессе
        обучения. 
      </p>
      <p> </p>
      <p>2. Обучение, как средство воспитания</p>
      <p>
        Обучение, как деятельность обучающегося, в результате которой он
        усваивает знания, формирует умения и навыки, выступает одним из ведущих
        воспитательных средств, обеспечивая целенаправленное формирование
        отношения обучающегося к будущей сфере профессиональной деятельности. В
        ходе обучения воспитывающее влияние на обучающихся оказывают содержание
        изучаемого материала, формы и методы учебной работы, личность
        преподавателя, его отношение к обучающимся, к труду.
      </p>
      <p>
        Эффективность воспитательного воздействия обучения значительно
        повышается, когда на уроке практикуется так называемая совместная
        продуктивная деятельность обучающихся. В основе такой деятельности лежит
        учебное взаимодействие, в ходе которого обучающиеся:
      </p>
      <p>а- выясняют условия совместного выполнения задания;</p>
      <p>б- организуют его взаимное обсуждение;</p>
      <p>в- фиксируют ход совместной работы;</p>
      <p>г- обсуждают полученные результаты;</p>
      <p>д- совместно решают, как будут отчитываться о выполнения задания;</p>
      <p>е- проверяют и оценивают итоги совместно проделанной работы. </p>
      <p> </p>
      <p>
        Обеспечение доступа в здание учебного центра инвалидов и лиц с
        ограниченными возможностями здоровья  
      </p>
      <p>Кнопка-звонок вызова персонала - в наличии (на фасаде знания).</p>
      <p>
        Условия питания обучающихся, в том числе инвалидов и лиц с ограниченными
        возможностями здоровья
      </p>
      <p>
        Организация питания обучающихся в Центре не предусмотрена.  Тем не
        менее, в   Учебном центре имеется комната для самостоятельного приема
        пищи обучающимися. Комната оборудована 1 (одним) столом на 8 мест. В
        комнате имеется микроволновая печь. Чайник. В необходимом количестве
        закупается одноразовая посуда. Заключен договор на поставку питьевой
        воды с ООО «Агидель».
      </p>
      <p>
        Комната для приема пищи расположена на первом этаже, обеспечен доступ
        для маломобильных обучающихся, дверной проем в комнату расширен.
      </p>
      <p> </p>
      <p>
        Условия питания и охраны здоровья обучающихся инвалидов и лиц с
        ограниченными возможностями здоровья
      </p>
      <p>
        Охрана здоровья обучающихся, в том числе инвалидов и лиц с ограниченными
        возможностями здоровья включает в себя:
      </p>
      <p>
        - оказание первичной медико-санитарной помощи в порядке,
        установленном законодательством в сфере охраны здоровья;
      </p>
      <p>- определение оптимальной учебной нагрузки, режима учебных занятий;</p>
      <p>
        - пропаганду и обучение навыкам здорового образа жизни, требованиям
        охраны труда;
      </p>
      <p>
        - профилактику и запрещение курения, употребления алкогольных,
        слабоалкогольных напитков, пива, наркотических средств и психотропных
        веществ, их прекурсоров и аналогов и других одурманивающих веществ;
      </p>
      <p>- обеспечение безопасности во время пребывания в Центре;</p>
      <p>- профилактику несчастных случаев во время пребывания в Центре;</p>
      <p>
        - проведение санитарно-противоэпидемических и профилактических
        мероприятий;
      </p>
      <p>
        - обучение педагогических работников и работников Учебного центра
        навыкам оказания первой доврачебной помощи.
      </p>
      <p>
        Центр создает условия для охраны здоровья обучающихся, в том числе
        инвалидов и лиц с ограниченными возможностями здоровья:
      </p>
      <p>
        - проведение санитарно-гигиенических, профилактических и оздоровительных
        мероприятий, обучение и воспитание в сфере охраны здоровья граждан в
        Российской Федерации;
      </p>
      <p>
        - соблюдение государственных санитарно-эпидемиологических правил и
        нормативов;
      </p>
      <p>
        - расследование и учет несчастных случаев с обучающимися во время
        пребывания в Центре в порядке, установленном федеральным органом
        исполнительной власти, осуществляющим функции по выработке
        государственной политики и нормативно-правовому регулированию в сфере
        образования, по согласованию с федеральным органом исполнительной
        власти, осуществляющим функции по выработке государственной политики и
        нормативно-правовому регулированию в сфере здравоохранения.
      </p>
      <p> </p>
      <p>
        Сведения о доступе к информационным системам и информационно –
        телекоммуникационным сетям, в том числе приспособленным для
        использования инвалидами и лицами с ограниченными возможностями здоровья
      </p>
      <p>
        Одним из приоритетных направлений в деятельности ЧОУ ДПО «Профф» на
        2019- 2021г.г. является информатизация образовательного процесса,
        которая рассматривается как процесс, направленный на повышение
        эффективности и качества учебных занятий, и администрирования
        посредством применения ИКТ (информационно-коммуникативных технологий).
      </p>
      <p>
        На сегодняшний день обучающиеся имеют возможность работать в сети
        Интернет на уроках и ежедневно в свободном доступе после уроков в
        кабинетах № 1,2,3,4,5,6,7,8. В свободное от уроков время каждый желающий
        (преподаватель или обучающийся) при помощи точки доступа к сети Интернет
        может воспользоваться техническими и сетевыми ресурсами для выполнения
        учебных задач.
      </p>
      <table>
        <thead>
          <tr className='header'>
            <th>Наименование</th>
            <th>Количество</th>
          </tr>
        </thead>
        <tbody>
          <tr className='odd'>
            <td className='border border-gray-500'>
              Наличие в образовательной организации электронной
              информационно-образовательной среды
            </td>
            <td className='border border-gray-500'>Да</td>
          </tr>
          <tr className='even'>
            <td className='border border-gray-500'>
              Общее количество компьютеров с выходом в
              информационно-телекоммуникационную сеть «Интернет», к которым
              имеют доступ обучающиеся
            </td>
            <td className='border border-gray-500'>10</td>
          </tr>
          <tr className='odd'>
            <td className='border border-gray-500'>
              Наличие сторонних электронных образовательных и информационных
              ресурсов
            </td>
            <td className='border border-gray-500'>9</td>
          </tr>
        </tbody>
      </table>
      <p> </p>
      <p>
        Сведения о доступе к информационным системам и информационно –
        телекоммуникационным сетям, приспособленным для использования инвалидами
        и лицами с ограниченными возможностями здоровья
      </p>
      <p>
        Операционные системы имеют специальные режимы (крупный текст,
        контрастная схема, отказ от фоновых изображений, «проговаривание»
        голосом действий и текстов на экране).
      </p>
      <p>
        LMS Moodle с размещенными в ней методическими и учебными материалами, с
        возможностью увеличивать шрифт, загружать аудиофайлы, демонстрирующие
        выполнение задание обучающимся.
      </p>
      <p>
        В сети Интернет размещена специальная версия сайта для лиц с нарушением
        зрения - версия сайта для слабовидящих.
      </p>
      <p> </p>
      <p>
        Сведения об электронных образовательных ресурсах, в том числе
        приспособленных для использования инвалидами и лицами с ограниченными
        возможностями здоровья
      </p>
      <p>
        Учебные места имеют контролируемый доступ к сети интернет к следующим
        электронным ресурсам:
      </p>
      <p>
        1. 
        <a href='http://school-collection.edu.ru/'>
          <u>Единая коллекция цифровых образовательных ресурсов</u>
        </a>
      </p>
      <p>
        В настоящее время в Коллекции размещено более 111 000 цифровых
        образовательных ресурсов, инновационные учебно-методические разработки,
        разнообразные тематические и предметные коллекции, а также другие
        учебные, культурно-просветительские и познавательные материалы.
      </p>
      <p>
        2. 
        <a href='http://fcior.edu.ru/'>
          <u>Федеральный центр информационно-образовательных ресурсов</u>
        </a>
      </p>
      <p>
        Сайт ФЦИОР обеспечивает каталогизацию электронных образовательных
        ресурсов различного типа за счет использования единой информационной
        модели метаданных, основанной на стандарте LOM. Электронные учебные
        модули создаются по тематическим элементам учебных предметов и дисциплин
        и представляют собой законченные интерактивные мультимедиа продукты,
        нацеленные на решение определенной учебной задачи.
      </p>
      <p>
        3. 
        <a href='http://window.edu.ru/'>
          <u>Единое окно доступа к информационным ресурсам</u>
        </a>
      </p>
      <p>
        Информационная система &#34;Единое окно доступа к образовательным
        ресурсам&#34; предоставляет свободный доступ к каталогу образовательных
        интернет-ресурсов и полнотекстовой электронной учебно-методической
        библиотеке для общего и профессионального образования.
      </p>
      <p>
        4. 
        <a href='http://www.edu.ru/'>
          <u>Федеральный портал «Российское образование»</u>
        </a>
      </p>
      <p>
        Портал «Российское образование» - крупнейший образовательный каталог в
        России. Он содержит полные базы образовательных учреждений всех ступеней
        и научно-исследовательских институтов Российской Федерации.
      </p>
      <p>
        5. 
        <a href='https://www.consultant.ru/'>
          <u>СПС Консультант-Плюс</u>
        </a>
      </p>
      <p>
        6. 
        <a href='https://rusneb.ru/'>
          <u>Национальная электронная библиотека</u>
        </a>
      </p>
      <p>
        7. 
        <a href='https://www.rsl.ru/'>
          <u>Российская государственная библиотека</u>
        </a>
      </p>
      <p>
        8. 
        <a href='https://www.minobrnauki.gov.ru/'>
          <u>Министерство науки и высшего образования РФ</u>
        </a>
      </p>
      <p>
        9. 
        <a href='https://edu.gov.ru/'>
          <u>Министерство просвещения РФ</u>
        </a>
      </p>
      <p>
        Перечень электронных образовательных ресурсов, приспособленных для
        использования инвалидами и лицами с ограниченными возможностями здоровья
      </p>
      <p>
        Информационная система LMS Moodle для самостоятельной работы с учебными
        и методическими материалами по программам ДПО и профессионального
        обучения. В личном кабинете возможно увеличение масштаба включением
        планшетного/мобильного дизайна на обычном мониторе, что не только
        увеличивает размер текстов, но и удаляет необязательные элементы
        интерфейса, делая работу слабовидящих студентов более комфортной.
      </p>
      <p>
        Сведения о наличии специальных технических средств обучения
        коллективного и индивидуального пользования для инвалидов и лиц с
        ограниченными возможностями здоровья
      </p>
      <p>
        На официальном сайте ЧОУ ДПО «Профф» в сети Интернет размещена
        специальная версия сайта для лиц с нарушением зрения - версия сайта для
        слабовидящих.
      </p>
      <p>
        Учебная аудитории № 2 оснащена мультимедийным оборудованием -
        звукоусиливающая аппаратура, проектором для облегчения освоения учебного
        материала и повышения уровня восприятия учебной информации обучающимися
        с различными нарушениями. 
      </p>
      <p>
        Дополнительные требования к компьютерной технике для облегчения
        возможности успешного прохождения обучения лицами с ограниченными
        возможностями здоровья реализуются с помощью стандартных средств
        &#34;Центра специальных возможностей&#34; операционной системы Windows.
      </p>
      <p>
        Теоретические и практические занятия проводятся в учебных кабинетах,
        оснащенных разборными и неразборными муляжами. Кроме того, слабовидящие
        обучающиеся смогут выполнять домашние задания в электронном формате с
        возможностью использования персонального компьютера. Таким обучающимся
        будут выдаваться Методические указания, напечатанные размером шрифта не
        менее 18, или в электронной форме.
      </p>
      <p>
        В Учебном центре имеются в наличии учебные пособия и дидактические
        материалы в электронном формате, доступ к которым и просмотр которых
        возможен с помощью любого цифрового устройства (ПК, планшет, смартфон и
        др.), подключенного к сети Интернет и имеющих специальные возможности
        (увеличение шрифта, программа звукового воспроизведения текста), в том
        числе на территории техникума.
      </p>
      <p>
        Форма проведения текущей и итоговой аттестации для инвалидов может быть
        установлена с учетом индивидуальных психофизических особенностей (устно,
        письменно на бумаге, в форме тестирования и т.п.). При необходимости
        проводится подбор и разработка учебных материалов в печатных и
        электронных формах, адаптированных к ограничениям их здоровья.
      </p>
      <p>
        Обучающимся с ограниченными возможностями здоровья для выполнения
        задания предусмотрен более продолжительный промежуток времени.
      </p>
      <p>
        Учебные кабинеты оборудованы специальными техническими средствами
        обучения коллективного и индивидуального пользования, в том числе для
        обучающихся инвалидов и обучающихся с ОВЗ. Это:
      </p>
      <p>- ноутбуки ученические,</p>
      <p>- звукоусиливающая аппаратура,</p>
      <p>- проекторы,</p>
      <p>- МФУ.</p>
    </div>
  );
};

export default Materialno;
